import axios from "axios";
import { IPublicClientApplication } from "@azure/msal-browser";
import { apiRequest } from "../authConfig";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

export interface BatchColorSetting {
  colorValue: string;
  label: string;
  isEnabled: boolean;
  sortOrder: number;
  hexColor: string | null;
  icon: string | null;
}

const authConfig = async (instance: IPublicClientApplication, account: any) => {
  const response = await instance.acquireTokenSilent({ ...apiRequest, account });
  return { headers: { Authorization: `Bearer ${response.accessToken}` } };
};

export const getBatchColorSettings = async (
  instance: IPublicClientApplication,
  account: any,
): Promise<BatchColorSetting[]> => {
  const config = await authConfig(instance, account);
  const res = await axios.get<BatchColorSetting[]>(`${API_URL}/batchcolor`, config);
  return res.data;
};

export const updateBatchColorSetting = async (
  instance: IPublicClientApplication,
  account: any,
  colorValue: string,
  setting: { label: string; isEnabled: boolean; hexColor?: string | null; icon?: string | null },
): Promise<BatchColorSetting> => {
  const config = await authConfig(instance, account);
  const res = await axios.put<BatchColorSetting>(
    `${API_URL}/batchcolor/${colorValue}`,
    setting,
    config,
  );
  return res.data;
};

export const createBatchColor = async (
  instance: IPublicClientApplication,
  account: any,
  data: { label: string; hexColor: string; icon?: string | null },
): Promise<BatchColorSetting> => {
  const config = await authConfig(instance, account);
  const res = await axios.post<BatchColorSetting>(`${API_URL}/batchcolor`, data, config);
  return res.data;
};

export const deleteBatchColor = async (
  instance: IPublicClientApplication,
  account: any,
  colorValue: string,
): Promise<void> => {
  const config = await authConfig(instance, account);
  await axios.delete(`${API_URL}/batchcolor/${colorValue}`, config);
};
